<template>
  <div id="app">
    <div class="overflow-x-auto whitespace-no-wrap mb-6">
      <transition-group name="list-complete">
        <div
          v-for="(card, index) in cards"
          :key="card.id"
          class="not-card text-center"
          v-if="maybesorting.indexOf(card.id) !== -1"
        >
          <span>
                {{ card.attributes['title'].text }} <br/>
                <input type="hidden" id="MaybeMe">
                <button class="btn btn-sm bg-green-600 hover:bg-green-800"  @click="MaybeMe(card.id)">Maybe Me</button>
          </span>
        </div>
      </transition-group>
    </div>
    
    <div class="overflow-x-auto whitespace-no-wrap text-center">
      <transition-group name="list-reverse">
        <div
          v-for="card in cards"
          :key="card.id"
          class="comparison-card text-center"
          v-show="maybesorting.indexOf(card.id) == -1"
          transition="fade"
        >
          <span>
                {{ card.attributes['title'].text }} <br/>
                <input type="hidden" id="NotMe">
                <button class="btn btn-sm bg-red-600 hover:bg-red-800" @click="NotMe(card.id)"><i aria-hidden="true" class="material-icons align-middle">close</i>Not Me</button>
          </span>
        </div>
      </transition-group>
    </div>
    <div class="overflow-x-auto whitespace-no-wrap text-center">
      <div
          v-for="card in cards"
          :key="card.id"
          class="comparison-dots text-center inline-block"
          v-if="maybesorting.indexOf(card.id) == -1"
        >
          .
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  props: {
      array: '',
      maybe: '',
      merged: [],
      route:'',
  },
  data () {
    return {
      cards: this.array,
      maybesorting: this.maybe,
    }
  },
  methods: {
    maybeContains(n) {
      return this.maybe.indexOf(n)
    },
    NotMe(id){
        this.maybe.unshift(id);
        console.log('Moved to Maybe Me');
    },
    MaybeMe(id){
        var index = this.maybe.indexOf(id);
        this.maybe.splice(index, 1);
        console.log('Moved to Not Me');
    },
  }
};
</script>

<style>
.not-card {
  align-items: center;
  background-color: pink;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: inline-block;
  font-size: 12px;
  height: 50px;
  justify-content: center;
  width: 150px;
  margin-right: 5px;
  transition: all 200ms;
}
.comparison-card {
  align-items: center;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: inline-block;
  font-size: 22px;
  height: 100px;
  justify-content: center;
  width: 150px;
  transition: all 200ms;
}
</style>
